import { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';
import { CardMedia } from '@mui/material';

const HLSPlayer = ({ cdn77PathUrl, azurePublicUrl }) => {
	const videoRef = useRef(null);
	const [isError, setIsError] = useState(false);

	useEffect(() => {
		try {
			if (videoRef.current) {
				// If HLS.js is supported (not Safari)
				if (Hls.isSupported()) {
					const hls = new Hls();

					hls.on(Hls.Events.ERROR, (_, data) => {
						if (data.fatal) {
							console.log('Error loading HLS stream:', data);
							setIsError(true);
						}
					});

					hls.loadSource(cdn77PathUrl);
					hls.attachMedia(videoRef.current);

					return () => {
						hls.destroy();
					};
				}
				// If native HLS is supported (e.g., Safari)
				else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
					videoRef.current.src = cdn77PathUrl;
					videoRef.current.onerror = () => {
						setIsError(true);
					};
				}
			}
		} catch (error) {
			console.log('Error while displaying HLS media - ', error);
		}
	}, [cdn77PathUrl]);

	// If there's an error in hls video, fallback card media will render the video
	if (isError) {
		return <CardMedia component="video" sx={{ height: '15rem' }} controls src={azurePublicUrl} />;
	}

	return <video ref={videoRef} controls width="100%" />;
};

export default HLSPlayer;
